import type { GetFiatWalletsParams } from '../types/walletTypes'

export const fiatWalletsKeys = {
  all: ['fiatWallets'] as const,
  // List of fiat wallets (one per investor + currency).
  lists: () => [...fiatWalletsKeys.all, 'list'] as const,
  list: (filters: GetFiatWalletsParams) => [...fiatWalletsKeys.lists(), filters] as const,
  // Per-investor transactions list (the existing ledger view).
  transactions: (investorId?: string) =>
    [...fiatWalletsKeys.all, 'transactions', { investorId }] as const,
}
